/* eslint-disable @atlaskit/design-system/ensure-design-token-usage-spacing */
import { css } from '@emotion/react';

import { media } from '@atlaskit/primitives/responsive';

import { PAGE_GUTTER } from './constants';

const gutterStyles = css({
  paddingInline: PAGE_GUTTER.base,

  [media.above.sm]: {
    paddingInline: PAGE_GUTTER.sm,
  },

  [media.above.md]: {
    paddingInline: PAGE_GUTTER.md,
  },

  [media.above.lg]: {
    paddingInline: PAGE_GUTTER.lg,
  },
});

export default gutterStyles;
